/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import PropTypes from '../util/prop_types';
import { MapActionCreators } from '../stores/map_action_creators';
import { SidePanelSelectors } from '../stores/sidepanel_selectors';
import { SidePanelActionCreators } from '../stores/sidepanel_action_creators';
import SearchResultItem from './search_result_item';

const mapStateToProps = (state) => {
  return {
    query: SidePanelSelectors.getQuery(state),
    page: SidePanelSelectors.getSearchResultsPage(state),
    hasPrevPage: SidePanelSelectors.hasPrevSearchPage(state),
    hasNextPage: SidePanelSelectors.hasNextSearchPage(state),
    numResults: SidePanelSelectors.getNumSearchResults(state),
    activeId: SidePanelSelectors.getActiveId(state),
  }
}

const mapDispatchToProps = {
  toggleCollapsed: SidePanelActionCreators.toggleCollapsed,
  setPageNumber: SidePanelActionCreators.setSearchResultsPageNum,
  setHoverId: MapActionCreators.setMarkerHoverId,
  setPopup: MapActionCreators.setPopup,
};

class SearchResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prevQuery: '',
    }
  }

  static propTypes = {
    query: PropTypes.string.isRequired,
    page: PropTypes.immutable.map.isRequired,
    hasPrevPage: PropTypes.bool.isRequired,
    hasNextPage: PropTypes.bool.isRequired,
    numResults: PropTypes.number.isRequired,
    activeId: PropTypes.number.isRequired,
    toggleCollapsed: PropTypes.func.isRequired,
    setPageNumber: PropTypes.func.isRequired,
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.prevQuery != nextProps.query) {
      this.setState({ prevQuery: nextProps.query });
    }
  }

  onPrevPage = () => {
    this.props.setPageNumber(this.props.page.get('number') - 1);
  }

  onNextPage = () => {
    this.props.setPageNumber(this.props.page.get('number') + 1);
  }

  render(): ?React.Element<any> {
    const { props, state } = this;

    if (props.page.isEmpty()) {
      return (
        <div id="no-results">
          Sorry, we couldn't find {props.query}
        </div>
      );
    }
    else {
      const startItem = props.page.get('start');

      var resultItems = props.page.get('results').map((result, i) => {
        var id = startItem + i;

        const selectionHandler = () => {
          const geometry = result.item.geometry.coordinates;
          this.props.setPopup(geometry[0], geometry[1], result.item);

          if (window.innerWidth < 600) {
            this.props.toggleCollapsed();
          }
        };
        const focusHandler = () => {
          this.props.setHoverId(id);
        };
        const blurTimeoutHandler = () => {
          this.props.setHoverId(null);
        };

        return (
          <SearchResultItem
            key={result.item.id || id}
            markerId={id}
            isActive={i == props.activeId - 1}
            result={result}
            onSelection={selectionHandler}
            onFocus={focusHandler}
            onBlur={blurTimeoutHandler} />
        );
      });

      return (
        <div id="results-container">
          <div id="results">
            <ol id="search-results"
              className="marker-list"
              role="listbox">
              {resultItems}
            </ol>
          </div>
          <div id="results-pagination">
            Showing results {props.page.get('start')} - {props.page.get('end')} of {props.numResults}
            <button
              id="results-pagination-prev"
              tabIndex="0"
              aria-label="previous page"
              disabled={!props.hasPrevPage}
              onClick={this.onPrevPage}>
              <FontAwesome
                name="angle-left"
                fixedWidth />
            </button>
            <button
              id="results-pagination-next"
              tabIndex="0"
              aria-label="next page"
              disabled={!props.hasNextPage}
              onClick={this.onNextPage}>
              <FontAwesome
                name="angle-right"
                fixedWidth />
            </button>
          </div>
        </div>
      );
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults);
